import React from 'react';
import { Spinner } from 'react-bootstrap';
import { usePatientService } from '~/services';
import { enumValue, gapIsFailed, gapIsPending } from '~/util';
import { useRoleActions } from '~/util/useRoleActions';

interface UnanswerProps {
    hcc: RiskGapType;
    patientId: number;
}
export function Unanswer({ hcc, patientId }: UnanswerProps) {
    const { deleteSubmissionAnswer, updateRiskGap } = usePatientService();
    const canUnanswer = useRoleActions('allow_save_edit_answer_risk_gap');
    const [saving, setSaving] = React.useState(false);

    const shouldDisplay =
        canUnanswer &&
        (gapIsPending(hcc) || gapIsFailed(hcc)) &&
        !hcc.is_added &&
        hcc.submission_answer;

    async function unset() {
        setSaving(true);
        if (enumValue(['submission', 'status', 'New']) === hcc.submission_answer?.status) {
            await deleteSubmissionAnswer(
                enumValue(['gap', 'type', 'Risk Gap']) as number,
                hcc.id,
                hcc.submission_answer.id
            );
        } else {
            await updateRiskGap(hcc.id, patientId, {
                submission_answer: null,
                updated_at: hcc.updated_at,
            });
        }
        setSaving(false);
    }

    return shouldDisplay ? (
        <div className="text-center">
            <button className="btn btn-warning" type="button" disabled={saving} onClick={unset}>
                {saving && <Spinner animation="border" size="sm" role="status" className="me-2" />}
                Clear
            </button>
        </div>
    ) : null;
}
